import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { resetError } from 'store/Pipelines/actions';
import { selectError, selectErrorMessage } from 'store/Pipelines/selectors';
import ErrorDialog from 'Common/Components/ErrorDialog';
import List from './components/List';
import Detail from './components/Detail';
import { Wrapper } from './styled';

const Pipelines = ({ isNew, match }) => {
  const dispatch = useDispatch();
  const error = useSelector(selectError);
  const errorMessage = useSelector(selectErrorMessage);
  return (
    <Wrapper>
      <List />
      <Detail isNew={ isNew } match={ match } />
      { error ? <ErrorDialog message={ errorMessage } resetError={ () => dispatch(resetError()) } /> : null }
    </Wrapper>
  );
};

Pipelines.propTypes = {
  isNew: PropTypes.bool.isRequired,
  match: PropTypes.instanceOf(Object).isRequired
};

export default Pipelines;
